import consumer from "../channels/consumer";
import { Turbo } from "@hotwired/turbo-rails"

document.addEventListener("DOMContentLoaded", () => {
  const subscribeToChannel = !!document.getElementById("mockIndex");
  if (subscribeToChannel) {
    consumer.subscriptions.create("MockNotificationsChannel", {
      received(data) {
        Turbo.visit(location.toString());
      }
    });
  }
});
